import React, { useCallback, useEffect, useState } from 'react';
import searchIconIMG from "../../assets/images/megnificant-glass.png";
import Location from '../../components/Map/Location';
import CommonTable from '../../components/Table/CommonTable';
import AddZones from '../../components/AddZones/AddZones';
import useApi from '../../hook/useAPI';
import { ZONES, MONTHS, DEVICE } from '../../utils/const';
import Menu from "../../assets/images/Menu.png";
import Timer from '../../components/Timer/timer';
import { useTimerHandlers } from './timerHandler';
import { use } from 'react';
import ZoneDeviceList from '../../components/AddZones/ZoneDeviceList';
import { set } from 'lodash';
import { convert } from '../../utils/moment';
import socketFunc from '../../utils/socket';
import { mergeSocketIntoDeviceArray } from '../../hook/useDeviceStatusSocket';

const ZONE_LIST_LIMIT = 100;

function ZonesActivity() {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [zoneList, setZoneList] = useState();
  const [zoneDevicesList, setZoneDevicesList] = useState();
  const [zoneActivity, setZoneActivity] = useState();
  const [selectedZone, setSelectedZone] = useState(null);
  const { getData } = useApi();
  const [center, setCenter] = useState({ lat: 33.5779, lng: -101.8552 });
  const [currentZoneDeviceList, setCurrentZoneDeviceList] = useState(null);
  const [showTimer, setShowTimer] = useState(false);
  const [showZoneDetail, setShowZoneDetail] = useState(false);
  const [zoneDetail, setZoneDetail] = useState(null);
  const [timerData, setTimerData] = useState(null);
  const [isNewZone, setIsNewZone] = useState(false);
  const [currentZoneTimer, setCurrentZoneTimer] = useState(null);
  const [currentSelectedZone, setCurrentSelectedZone] = useState(null);
  const { startTimer, stopTimer, resumeTimer, pauseTimer, getTimerData } = useTimerHandlers();
  const [resetTimer, setResetTimer] = useState(false);


  const columnsOptions = [
    { header: "Device Name", key: 'deviceName' },
    { header: "Zone Name", key: 'name', },
    { header: "Zone Address", key: 'location', },
    { header: "Duration", key: 'duration', },
    { header: "Distance Radius", key: 'distance', },
    { header: "Date / Time", key: 'date' }
  ]
  const openDeviceZoonDetail = (item) => {
    setIsNewZone(false);
    setCurrentSelectedZone(item);
    setZoneDetail(item);
    setSelectedZone({ lat: parseFloat(item.latitude), lng: parseFloat(item.longitude), miles: item?.radiusInMiles });
    if (item?.latitude && item?.longitude) {
      const location = { lat: Number(item?.latitude), lng: Number(item?.longitude) }
      setCenter(location)
    }
  }

  const filterDevicesForZone = useCallback((devices, zone) => {
    if (!devices?.length) {
      return devices;
    }
    if (!zone?.devices?.length) {
      return devices;
    }
    const zoneDeviceIds = new Set(zone.devices.map((id) => String(id)));
    return devices.filter((device) => zoneDeviceIds.has(String(device.deviceId)));
  }, []);

  useEffect(() => {
    if (!zoneDevicesList) {
      return;
    }
    setCurrentZoneDeviceList(filterDevicesForZone(zoneDevicesList, currentSelectedZone));
  }, [zoneDevicesList, currentSelectedZone, filterDevicesForZone]);

  const handleZoneMapSocketUpdate = useCallback((payload) => {
    setZoneDevicesList((prev) => mergeSocketIntoDeviceArray(prev, payload));
  }, []);

  useEffect(() => {
    if (!zoneDevicesList?.length) {
      return;
    }
    const socketDevices = zoneDevicesList.map((device) => ({
      _id: device.deviceId || device._id,
    }));
    socketFunc(socketDevices, null, handleZoneMapSocketUpdate);
  }, [zoneDevicesList, handleZoneMapSocketUpdate]);
  const fetchDevices = async () => {
    try {
      let ss = '';
      if (currentSelectedZone && currentSelectedZone._id) {
        ss = `&zoneId=${currentSelectedZone._id}`;
      }

      const response = await getData(`${DEVICE?.GET_DEVICE_LOCATIONS_v2}/?page=${1}&limit=${10}${ss}`);

      if (response.status === 200 && response?.data.length > 0) {

        setZoneDevicesList(response.data);
      } else {
        console.log('Failed to fetch zone device details.');
      }
    } catch (err) {
      console.error("Error fetching zone device details:", err);
    }
  };
  const fetchZone = async (queryParams = "") => {
    try {
      const response = await getData(`${ZONES?.GET_ALL_ZONES}/?page=${1}&limit=${ZONE_LIST_LIMIT}`);

      if (response.status === 200 && response?.data.length > 0) {
        setZoneList(response?.data);
        const location = { lat: Number(response?.data[0]?.latitude), lng: Number(response?.data[0]?.longitude) }
        setCenter(location)
      } else {
        console.log('Failed to fetch zone details.');
      }
    } catch (err) {
      console.error("Error fetching zone details:", err);
    }

    fetchDevices();

    try {
      const response = await getData(`${ZONES?.GET_ZONE_ACTIVITY}?page=${currentPage}&limit=${itemsPerPage}&search=${queryParams}`);
      if (response.status === 200 && response?.data.length > 0) {


        const zoneActivitiesList = response?.data?.map(async (data, index) => {

          let singleZone = {
            deviceName: "",
            name: '',
            location: '',
            duration: '',
            distance: '',
            date: ''
          }

          // const ZoneAddress = await getAddress(data.zoneActivities[0].zoneLatitude, data.zoneActivities[0].zoneLongitude);
          const ZoneAddress = data.zoneActivities[0]?.zone_address || "-";

          const startTime = new Date(data.zoneActivities[0]?.dateTime);
          const endTime = new Date(data?.zoneActivities[data?.zoneActivities?.length - 1]?.dateTime);
          const durationInMilliseconds = endTime - startTime;


          const totalSeconds = Math.floor(durationInMilliseconds / 1000);
          const hours = Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;

          let formattedDuration = "";

          if (hours > 0) {
            formattedDuration += `${hours} hr `;
          }
          if (minutes > 0 || hours > 0) {
            formattedDuration += `${minutes} min `;
          }
          if (seconds > 0 || (!hours && !minutes)) {
            formattedDuration += `${seconds} sec`;
          }

          formattedDuration = formattedDuration.trim()

          // const formattedDate = `${day} ${month} ${year} ${hours}:${minutes}:${seconds}`;
          const formattedDate = convert(endTime, "DD MMM YYYY HH:mm:ss");

          singleZone.deviceName = data?.zoneActivities[0]?.deviceName;
          singleZone.name = data?.zoneActivities[0]?.zoneName;
          singleZone.distance = data?.zoneActivities[0].zoneRadius + " miles";
          singleZone.date = formattedDate;
          singleZone.duration = formattedDuration;
          singleZone.location = ZoneAddress;

          return singleZone;
        })

        // setZoneActivity(response?.data)
        Promise.all(zoneActivitiesList).then((zoneActivityList) => {
          setZoneActivity(zoneActivityList);
        }).catch((error) => {
          console.error("Error Processing zone", error);
        })

      } else {
        console.log('Failed to fetch zone device details.');
      }
    } catch (err) {
      console.error("Error fetching zone device details:", err);
    }
  };

  useEffect(() => {
    fetchZone()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsPerPage])

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    // setCurrentPage(1);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleZoneSelection = (zone) => {
    setSelectedZone({ lat: parseFloat(zone.latitude), lng: parseFloat(zone.longitude), miles: zone?.radiusInMiles });
  };

  const setNewZoneCreation = (newZone) => {
    ;
    if (newZone) {
      setIsNewZone(true); setShowTimer(true); setShowZoneDetail(true);
    }
  }

  useEffect(() => {
    if (currentSelectedZone && isNewZone == false) {
      const getTimer = async () => {
        const timer = await getTimerData(currentSelectedZone._id);
        if (timer.result) {
          let data = timer.result;
          const td = {
            status: data.timer_status,
            start_time: data.start_time,
            adjust_start_time: data.final_adjust_ime,
            pause_time: data.pause_times,
            resume_time: data.resume_times,
          }
          setTimerData(td);
          setCurrentZoneTimer(timer.result);

          setResetTimer(false);
        } else {
          setTimerData(null);
          setCurrentZoneTimer(null);
          setResetTimer(true);
        }
        setShowTimer(true);
        setShowZoneDetail(true);
      }
      getTimer();
    }
  }, [currentSelectedZone]);

  const onCreateZone = async (zone) => {
    setCurrentSelectedZone(zone);
    setZoneDetail(zone);
  }

  return (
    <>
      <div className="dashboard">
        <div className="row">
          <div className="col-lg-7 col-xl-8">
            <div className="card map-height">
              <div className="card-body p-0">
                <Location center={center} setCenter={setCenter} selectedZone={selectedZone} zoneData={(zoneDetail) ? [currentSelectedZone] : zoneList} DevicesList={currentZoneDeviceList} />
                <Timer show={showTimer}
                  btnText={"Zone Timer"}
                  heading={currentSelectedZone?.name}
                  resetTimer={resetTimer}
                  timerData={timerData}
                  forceStart={isNewZone}
                  startEvent={async (start_time) => { let timer = await startTimer(start_time, currentSelectedZone._id); setCurrentZoneTimer(timer) }}
                  stopEvent={(end_date) => { stopTimer(end_date, currentZoneTimer._id); }}
                  resumeEvent={(new_start_time, resume_time) => { resumeTimer(resume_time, new_start_time, currentZoneTimer._id) }}
                  pauseEvent={(pause_date) => { pauseTimer(pause_date, currentZoneTimer._id) }} ></Timer>
              </div>
            </div>
          </div>

          <div className="col-lg-5 col-xl-4 ">
            {
              (showZoneDetail == false) ? (
                <AddZones handleMenu={openDeviceZoonDetail} onSelectZone={handleZoneSelection} handlezone={fetchZone} newZoneSelection={setNewZoneCreation} onCreateZone={onCreateZone} />
              ) : (
                <ZoneDeviceList zoneId={zoneDetail._id} zoneName={zoneDetail.name} onClose={() => { setShowTimer(false); setShowZoneDetail(false); setZoneDetail(null); setCurrentSelectedZone(null); }}></ZoneDeviceList>
              )
            }


          </div>
        </div>

        {/* common table card start  */}
        <div className="card">
          <div className="card-body p-0 ">
            <div className="home-table-chart-box">
              <div className="top_bar">
                <div className="card_title">Zone Activity</div>
                <div className="input-group">
                  <span className="input-group-text" id="basic-addon1">
                    <img
                      src={searchIconIMG}
                      className="ing-fluid"
                      alt="search-icon"
                    />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search or type a command"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    onChange={(e) => fetchZone(e.target.value)}
                  />
                </div>
              </div>

              {/* <CommonTable columns={columnsOptions} rows={rowData}/> */}
              <CommonTable
                columns={columnsOptions}
                rows={zoneActivity}
                itemsPerPage={itemsPerPage}
                totalPages={totalPages}
                currentPage={currentPage}
                onItemsPerPageChange={handleItemsPerPageChange}
                onPageChange={handlePageChange}
                isPagination
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ZonesActivity